// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bs_dd"};